import Rectange from "./math/Rectangle";

class DOMUtils {
  static getAngle(/** Node **/ node) {
    let tr = window.getComputedStyle(node, null).getPropertyValue("transform");
    let angle = 0;
    if (tr && tr != "none") {
      let values = tr.split("(")[1].split(")")[0].split(",");
      angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
      angle = Math.abs(angle < 0 ? 360 + (angle % 360) : angle % 360);
    }

    return angle;
  }

  static getRectangle(/** Node **/ node) {
    let tl = {
      x: node.offsetLeft,
      y: node.offsetTop,
    };

    let br = {
      x: tl.x + node.offsetWidth,
      y: tl.y + node.offsetHeight,
    };

    let rect = new Rectange(tl, { x: br.x, y: tl.y }, { x: tl.x, y: br.y }, br);
    rect.rotate(DOMUtils.getAngle(node));

    return rect;
  }
}

export default DOMUtils;
